import { backendAPI } from '../../helper/apis';

export function saveEvaluationScheduleDate(params, _id) {
  if (_id) {
    return backendAPI.put(`/lead/schedule/date/${_id}`, params);
  }
  return backendAPI.post(`/lead/schedule/date`, params);
}